export * from "./setupDatadog";
import datadog from "./setupDatadog";
export default datadog;
export * from "./appenders";
